import type {
  TaskGroupSourceTypeApi,
  TaskGroupStatusApi,
} from 'api-typings/tasklist/tasklist';
import type { Group } from '../groups';
import type { Project } from '../projects';
import type { User } from '../users';

/**
 * A task group contains task sections and a task section contains tasks.
 */
export interface TaskGroup {
  readonly id: number;
  readonly ownerId: number;
  // linkedSources contains all information about the linked source, such as the
  // id, created date etc. This should be used in the frontend.
  readonly linkedSources: readonly TaskGroupLinkedSource[];
  readonly status?: TaskGroupStatusApi;
  readonly name: string;
  readonly description?: string;
  readonly createdTime?: number;
  // linkedSourcesMinimal contains only the sourceType and sourceId to be used
  // for querying the datastore.
  readonly linkedSourcesMinimal: readonly MinimalTaskGroupLinkedSource[];

  readonly userId: number;
}

export interface TaskGroupLinkedSource {
  readonly id: number;
  readonly taskGroupId: number;
  readonly sourceId: number;
  readonly sourceType: TaskGroupSourceTypeApi;
  readonly createdTime: number;
}

export interface MinimalTaskGroupLinkedSource {
  readonly sourceId: number;
  readonly sourceType: TaskGroupSourceTypeApi;
}

// Same as TaskGroupSourceTypeApi but for the object types corresponding to each enum string
export type TaskGroupLinkedSourceObjectType = Project | Group | User;

// We check onboarding separately on /tasklists page, project's tasklists page etc.
export const PROJECT_TASK_GROUP_ONBOARDING_EVENT_NAME =
  'project-task-group-onboarding';
export const MAIN_TASK_GROUP_ONBOARDING_EVENT_NAME =
  'main-task-group-onboarding';
